<ng-container *transloco="let t; read: 'delete-viewer-confirmation'">
  <accredible-inline-confirmation
    [dataCy]="viewerId()"
    [confirmationText]="t('cancel_invitation', { count: deletionCount() })"
    [confirmButtonText]="t('cancel')"
    (cancel)="cancel($event)"
    (confirm)="delete($event)" />
</ng-container>
